import React from 'react';
import { gql } from '@apollo/client';
import { BooleanField, Show, SimpleShowLayout, TextField } from 'react-admin';
import { JsonField } from 'react-admin-json-view';
import LinkField from 'components/LinkField';

const QualificationAttributeShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="id" />
      <LinkField source="qualification.id" label="Qualification ID" />
      <TextField source="name" />
      <TextField source="slug" />
      <TextField source="field_type" />
      <BooleanField source="required" />
      <BooleanField source="required_for_approval" />
      <JsonField source="data" />
    </SimpleShowLayout>
  </Show>
);

QualificationAttributeShow.query = gql`
  query GET_ONE($id: Int!) {
    qualificationAttribute(id: $id) {
      id
      name
      slug
      field_type
      data
      required
      required_for_approval
      qualification {
        id
      }
    }
  }
`;

export default QualificationAttributeShow;
